import AlbumManualMatchingView from './AlbumManualMatchingView';

export default AlbumManualMatchingView;
